import { Injectable } from '@angular/core';

import { ComparisonOperator } from '@blaze-shared/api-contracts-domain';
import { DatasetColumn } from '@blaze-shared/schema-domain';

import {
  CONDITIONS_WITHOUT_VALUE,
  DEFAULT_OPERATOR_NAMES,
  OperatorName,
  OPERATORS_FOR_DATATYPES,
} from './models/intellisense-configuration';

@Injectable({ providedIn: 'root' })
export class IntelliQueryService {
  getComparisonOperatorName(
    operator: ComparisonOperator,
    column?: DatasetColumn | null,
  ): OperatorName {
    const name = DEFAULT_OPERATOR_NAMES[operator] || operator || 'Unknown operator';
    const columnDataType = column?.dataType || '';
    if (!columnDataType) {
      return name;
    }

    // Link, Tag
    const multipleValues = !!column?.multipleValues;
    if (
      multipleValues ||
      columnDataType === 'Array' ||
      columnDataType === 'Link' ||
      columnDataType === 'Tag'
    ) {
      switch (operator) {
        case ComparisonOperator.Eq:
          return multipleValues ? OperatorName.Contains : OperatorName.Is;
        case ComparisonOperator.NotIn:
          return multipleValues
            ? OperatorName.DoesNotContain
            : DEFAULT_OPERATOR_NAMES[ComparisonOperator.NotIn];
        default:
          break;
      }
    }

    return name;
  }

  getOperatorsForDataType(column?: DatasetColumn | null): ComparisonOperator[] {
    const columnDataType = column?.dataType || '';
    if (!columnDataType) {
      // Return all operators.
      return this.getOperatorsAsValues();
    }
    const operators = column?.multipleValues
      ? OPERATORS_FOR_DATATYPES['Array']
      : OPERATORS_FOR_DATATYPES[columnDataType];
    if (!operators) {
      // Return all operators.
      return this.getOperatorsAsValues();
    }
    return operators;
  }

  isQueryValueRequired(operator: ComparisonOperator): boolean {
    return !CONDITIONS_WITHOUT_VALUE.includes(operator);
  }

  private getOperatorsAsValues(): ComparisonOperator[] {
    return Object.values(ComparisonOperator) || [];
  }
}
